import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { I18n } from 'react-redux-i18n';
import grey from '@material-ui/core/colors/grey';

import MoreVertIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import TextField from '@material-ui/core/TextField';

import { EmailValidator } from './../validators';
import { forgotPass } from '../../redux/actions/authActions';

const styles = {
  checkRemember: {
    style: {
      float: 'left',
      maxWidth: 180,
      paddingTop: 5,
    },
    labelStyle: {
      color: grey[500],
    },
    iconStyle: {
      color: grey[500],
      borderColor: grey[500],
      fill: grey[500],
    },
  },
  loginBtn: {
    float: 'right',
  },
  btn: {
    background: '#4f81e9',
    color: grey[50],
    padding: 7,
    borderRadius: 2,
    margin: 2,
    fontSize: 13,
  },
  btnFacebook: {
    background: '#4f81e9',
  },
  btnGoogle: {
    background: '#e14441',
  },
  btnSpan: {
    marginLeft: 5,
  },
  center: {
    textAlign: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  }
};

const validate = values => {
  const errors = {};
  const requiredFields = ['email', 'password'];
  requiredFields.forEach(field => {
    if (!values[field]) {
      errors[field] = I18n.t('messages.required_field');
    }
  });
  if (!EmailValidator(values.email)) {
    errors.email = I18n.t('messages.invalid_email');
  }
  return errors
};

const form = reduxForm({
  form: 'ForgotPassForm',
  destroyOnUnmount: false,
  fields: ['email'],
  validate,
});

const mapStateToProps = state => ({
  loading: state.auth.loading,
});

const mapDispatchToProps = {
  forgotPass,
};

class ForgotPassForm extends React.Component {

  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    forgotPass: PropTypes.func.isRequired,
    router: PropTypes.any.isRequired,
  };

  constructor(props) {

    super(props);
    this.handleCloseErrors = this.handleCloseErrors.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      dialogErrorOpen: false,
      dialogErrorTitle: 'application.errors_found',
      messages: []
    }

  }

  onSubmit(data) {
    this.props.forgotPass(data).then(
      response => {

        if (!response.data.code) {

          this.setState({
            dialogErrorOpen: true,
            dialogErrorTitle: 'application.errors_found',
            messages: [I18n.t('messages.account_not_exists')]
          });

        } else {

          this.setState({
            dialogErrorOpen: true,
            dialogErrorTitle: 'application.success',
            messages: [I18n.t('messages.recovery_email_has_been_sent')]
          });

        }

      }
    );
  }

  handleCloseErrors() {
    this.setState({
      dialogErrorOpen: false,
      messages: []
    })
  }

  render() {

    const {handleSubmit, pristine, submitting, valid, loading} = this.props;

    return (
      <div>
        <form>

          <div>
            <Field name="email" component={TextField} hintText={I18n.t('fields.email')}
                   floatingLabelText={I18n.t('fields.email')} fullWidth={true}
                   disabled={loading}/>
          </div>

          <div>

            <Button
              variant="contained"
              label={I18n.t('application.recovery_pass')}
              primary
              style={styles.loginBtn}
              type="submit"
              onClick={handleSubmit(this.onSubmit)}
              disabled={pristine || submitting || !valid || loading}
            />

          </div>
        </form>
        <Dialog
          title={I18n.t(this.state.dialogErrorTitle)}
          open={this.state.dialogErrorOpen}
          actions={<Button
            label={I18n.t('application.close')}
            primary
            onTouchTap={this.handleCloseErrors}
          />}
        >

          <List>
            {this.state.messages.map((error, index) => {
              return <ListItem key={index} primaryText={error} leftIcon={<MoreVertIcon />}/>
            })}
          </List>

        </Dialog>
      </div>
    );

  }

}

export default withRouter(
  form(
    connect(mapStateToProps, mapDispatchToProps)(ForgotPassForm)
  )
);



// WEBPACK FOOTER //
// ./src/components/auth/ForgotPassForm.js